const e = "autocomplete_hsb2a", t = "searchLabel_YuasC", o = "searchLabel__text_lioOG", a = "searchLabel__active_ksoft", c = "input_PWCwy", s = "menu_UH6QF", _ = "menu__top_Y-Z5i", n = "geolocation_P9sr-", i = "predictionList_nOBYb", l = {
  autocomplete: e,
  searchLabel: t,
  searchLabel__text: o,
  searchLabel__active: a,
  input: c,
  menu: s,
  menu__top: _,
  geolocation: n,
  predictionList: i
};
export {
  e as autocomplete,
  l as default,
  n as geolocation,
  c as input,
  s as menu,
  _ as menu__top,
  i as predictionList,
  t as searchLabel,
  a as searchLabel__active,
  o as searchLabel__text
};
//# sourceMappingURL=autocomplete.module.scss.js.map
